
type Props = {
  className: string
}

export const WavySvg = ({ className }: Props) => {
  return (
    <svg x='0px' y='0px' viewBox='0 0 1512 75.9' className={className}>
      <path d='M1514.4,0.5c-157.7,25-548.3,66.5-850,32.1c-377-43-656,0-666.9,0l0,42.2c0,4.1,1011.2,1.7,1516.9,0V0.5z' />
    </svg>
  )
}
